import { IDeal } from '../../deals/interfaces';
import { ThunkAPI } from '../../../../rootReducer';
import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../../../../services/apiAsyncThunkCreator';
import { CORE_SERVICES, HttpMethods } from '../../../../../services/api';

export interface IFetchDealsListPayload {
  accountId: string;
  searchTerm?: string;
}

export const fetchDealsList: AsyncThunk<IDeal[], IFetchDealsListPayload, ThunkAPI> = createAsyncThunk(
  'creditPoolDistribution/fetchDealsList',
  async (payload: IFetchDealsListPayload, thunk) => {
    try {
      const data = {
        searchTerm: payload.searchTerm
      };
      return await basicApiAsyncThunkCreator<IDeal[], typeof data>({
        endpoint: `deals/distribution-deals/account/${payload.accountId}`,
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);
    } catch (err) {
      return thunk.rejectWithValue(err);
    }
  }
);
